<template>
	<div v-if="activeWidget" class="pa-3 d-flex flex-column wrapper">
		<template v-if="features.length">
			<v-carousel
				:show-arrows="false"
				hide-delimiters
				height="auto"
				light
				v-model="step"
				class="flex-grow-1"
			>
				<v-carousel-item
					v-for="(feature, i) in features"
					:key="i"
				>
					<div class="title">{{feature.get('title') || 'Nėra pavadinimo'}}</div>
					<div v-html="feature.get('description')"></div>
				</v-carousel-item>
			</v-carousel>
			<template v-if="features.length > 1">
				<div class="item-selector">
					<v-btn
						icon
						v-on:click="goToPrev"
						title="Ankstesnis"
						class="mr-1"
					>
						<v-icon size="40">mdi-chevron-left</v-icon>
					</v-btn>
					<template v-if="features.length > 8">
						{{(this.step + 1) + " iš " + features.length}}
					</template>
					<template v-else>
						<v-btn
							v-for="(feature, i) in features"
							:key="i"
							icon
							:title="feature.get('title') || 'Nėra pavadinimo'"
							:class="step == i ? 'selected' : ''"
							v-on:click="step = i"
						>
							<v-icon size="16">mdi-circle</v-icon>
						</v-btn>
					</template>
					<v-btn
						icon
						v-on:click="goToNext"
						title="Kitas"
						class="ml-1"
					>
						<v-icon size="40">mdi-chevron-right</v-icon>
					</v-btn>
				</div>
			</template>
		</template>
		<template v-else>
			<div>Objektų nėra</div>
		</template>
	</div>
</template>

<script>
	import VectorSource from "ol/source/Vector";
	import VectorLayer from "ol/layer/Vector";
	import Feature from "ol/Feature";
	import Point from "ol/geom/Point";
	import CommonHelper from "../../../../components/helpers/CommonHelper";

	export default {
		computed: {
			activeWidget: {
				get: function(){
					return this.$store.state.activeWidget;
				}
			}
		},
		data: function(){
			var data = {
				myMap: null,
				features: [],
				step: 0
			};
			return data;
		},
		methods: {
			addFeatures: function(myObjects){
				if (!this.myMap.myObjectsLayer) {
					this.myMap.myObjectsLayer = new VectorLayer({
						source: new VectorSource(),
						style: CommonHelper.getMyObjectsStyle(),
						zIndex: 1001
					});
					this.myMap.myObjectsLayer.getSource().on("addfeature", this.setFeatures);
					this.myMap.map.addLayer(this.myMap.myObjectsLayer);
				}
				if (myObjects) {
					var feature,
						features = [];
					myObjects.forEach(function(featureData){
						feature = new Feature({
							geometry: new Point(featureData.coordinates)
						});
						feature.set("color", featureData.color);
						if (featureData.attributes) {
							feature.set("title", featureData.attributes.title);
							feature.set("description", featureData.attributes.description);
						}
						features.push(feature);
					}.bind(this));
					this.myMap.myObjectsLayer.getSource().addFeatures(features);
					setTimeout(function(){
						// Hmmm... Dabar vis tiek pradžioje parodo visą aprėptį, o tik po to artina prie pirmo įrašo? Ar blogai? Jei blogai, reiktų koreguoti MyMap'o view'o kūrimą? Reiktų gauti pirmo taško koordinates ir jas naudoti vietoje centro koordinačių?
						this.highlightFeature(true);
					}.bind(this), 0);
				}
			},
			setFeatures: function(){
				var features = [];
				this.myMap.myObjectsLayer.getSource().forEachFeature(function(feature){
					features.push(feature);
				});
				CommonHelper.sortFeatures(features);
				this.features = features;
			},
			goToPrev: function(){
				var prevStep = this.step -= 1;
				if (prevStep < 0) {
					prevStep = this.features.length - 1;
				}
				this.step = prevStep;
			},
			goToNext: function(){
				var nextStep = this.step += 1;
				if (nextStep == this.features.length) {
					nextStep = 0;
				}
				this.step = nextStep;
			},
			highlightFeature: function(centerTo){
				if (this.activeFeature) {
					this.activeFeature.set("active", false);
				}
				this.activeFeature = this.features[this.step];
				if (this.activeFeature) {
					this.activeFeature.set("active", true);
					if (centerTo) {
						this.myMap.map.getView().animate({
							center: this.activeFeature.getGeometry().getCoordinates(),
							duration: 500
						});
					}
				}
			}
		},
		watch: {
			activeWidget: {
				handler: function(activeWidget){
					if (activeWidget && activeWidget.content.type == "map" && activeWidget.content.data && activeWidget.content.data.myMap) {
						this.myMap = activeWidget.content.data.myMap;
						this.addFeatures(activeWidget.content.data.myObjects);
					} else {
						this.myMap = null;
					}
				}
			},
			step: {
				handler: function(){
					this.highlightFeature(true);
				}
			}
		}
	}
</script>

<style scoped>
	.wrapper {
		height: 100%;
	}
	.selected {
		background-color: #dadada;
	}
	.v-carousel {
		overflow: auto;
	}
</style>